export enum FormKeys {
    PackName = 'name',
    Description = 'description',
    LabelName = 'label',
    Genre = 'genre',
    Subgenre = 'subgenre',
    GenreOptional = 'genreOptional',
    SubgenreOptional = 'subgenreOptional',
    Exclusivity = 'exclusive',
    Lexicon = 'lexicon',
}
